export default __webpack_public_path__ + "static/media/card-masha-1.66565956.png";